import fetch from "../utils/fetch";

//查询增设规则
export const getReleaseRules = (params) =>
  fetch(`/charge/rule/release`, {
    method: "get",
    params,
  });

//修改增设规则
export const editReleaseRules = (data) =>
  fetch(`/charge/rule/release`, {
    method: "put",
    data,
  });

//查询投放周期
export const getReleaseCycle = (params) =>
  fetch(`/charge/rule/cycle`, {
    method: "get",
    params,
  });

//修改投放周期
export const editReleaseCycle = (data) =>
  fetch(`/charge/rule/cycle`, {
    method: "put",
    data,
  });

//查询计费规则列表
export const getRule = (params) =>
  fetch(`/charge/rule/list`, {
    method: "get",
    params,
  });

//查询计费规则列表
export const addRule = (params) =>
  fetch(`/charge/rule`, {
    method: "get",
    params,
  });

export const deleteRule = (body) =>
  fetch(`/charge/rule`, {
    method: "delete",
    body,
  });

//查询计费规则列表
export const getDeductionList = (params) =>
  fetch(`/charge/rule/deduction/list`, {
    method: "get",
    params,
  });

export const setDeduction = (data) =>
  fetch(`/charge/rule/deduction`, {
    method: "put",
    data,
  });

export const getCompanyList = (params) =>
  fetch(`/charge/rule/operator/list`, {
    method: "get",
    params,
  });

export const getPositionList = (params) =>
  fetch(`/charge/rule/point/list`, {
    method: "get",
    params,
  });

export const addRules = (data) =>
  fetch(`/charge/rule`, {
    method: "post",
    data,
  });

export const editRule = (data) =>
  fetch(`/charge/rule`, {
    method: "put",
    data,
  });

export const getEvaluationList = (params) =>
  fetch(`/goods/evaluation/list`, {
    method: "get",
    params,
  });

export const getEvaluationDetail = (params) =>
  fetch(`/goods/evaluation/details`, {
    method: "get",
    params,
  });

  export const audit = (body) =>
  fetch(`/goods/evaluation/examine`, {
    method: "put",
    body,
  });